import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.img`
    max-height: 300px;
    max-width: 300px;
`

const ImagePreview = (props) => {
    const { src } = props

    const data = src instanceof File ? URL.createObjectURL(src) : src

    return <Container src={data} alt="" />
}

ImagePreview.propTypes = {
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]),
}

ImagePreview.defaultProps = {
    src: null,
}

export default ImagePreview
